import Vue from 'vue'
import VueRouter from 'vue-router'
import Bind from '@/views/bind/index.vue';
import Practice from '@/views/practice/index.vue';
import Design from '@/views/design/index.vue';
import Share from '@/views/share/index.vue';
import Pysearch from '@/views/pysearch/index.vue';
import TemplateIntro from '@/views/templateIntro/index.vue';
import { isTemplateShowcaseWork } from '@/mock/templateShowcase';
Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/practice' },
  { path: '/bind', component: Bind },
  { path: '/practice', component: Practice },
  { path: '/studio', component: Practice },
  { path: '/design', component: Design },
  { path: '/share', component: Share },
  { path: '/template-intro', component: TemplateIntro },
  { path: '/pysearch', component: Pysearch }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isEditorPath = to.path === '/practice' || to.path === '/studio';
  const isPrintedTemplateEntry = !!(
    isEditorPath
    && to.query.templateShareCode
    && to.query.productExpandId
    && to.query.enterEditor !== '1'
    && isTemplateShowcaseWork(to.query.productExpandId)
  );

  if (!isPrintedTemplateEntry) {
    next();
    return;
  }

  next({
    path: '/template-intro',
    query: {
      ...to.query,
      editorPath: to.path,
    },
    replace: true,
  });
});

export default router
